(function () {
  const faqSection = document.querySelector('.common-product-faq');
  const registrationSection = document.querySelector('.product-registration');
  registrationSection.appendChild(faqSection);

  const tenantId = '000000';
  const project = 'DREAME-MALL';
  const appSecret = 'R$t6y7U!w8Q#2%kJL';
  const appId = 'H2m7Q8x3J4';
  const baseUrl = 'https://us-store.dreame.tech/dreame-store';
  const api = {
    warranty: "/api/v1/warranty/get-by-sn",
    warrantyList: "/api/v1/warranty/list-by-email",
    // 注册产品
    productRegister: "/api/v1/product-register/create",
    registeredproducts: "/api/v1/product-register/list-register-by-email",
    unregisteredproducts: "/api/v1/product-register/list-unregistered-by-email",
    // 销售渠道
    purchaseChannelList: "/api/v1/purchase-channel/list",
    // 根据sn码获取产品信息
    snProductList: "/api/v1/product/list-product-model-by-sn",
    // 注册失败后一键修改订单日期
    modifyPurchaseDate: "/api/v1/product-register/modify-purchase-date",
    // 注册失败后重新注册
    productReRegister: "/api/v1/product-register/reregister",
  }
  /**
   * @param {String} api 
   * @param {RequestInfo} info 
   */
  const request = async (api, data, info) => {
    const body = data;
    // 获取 body 的参数 json
    const bodyString = JSON.stringify(body);
    const timestamp = Date.now();
    const stringSignTemp = bodyString + timestamp + appSecret;
    const sign = CryptoJS.MD5(stringSignTemp).toString();

    return fetch(baseUrl + api, {
      ...{
        method: 'POST',
        body: bodyString,
        headers: {
          tenant_id: tenantId,
          project: project,
          'dreame-api-sign': sign,
          'dreame-api-app-id': appId,
          'dreame-api-timestamp': timestamp.toString(),
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
      ...info ?? {}
    }).then((res) => {
      return res.json();
    }).catch((err) => {
      console.error(err);
      throw err;
    });
  }

  // Components
  /** 通用弹窗组件
   * $emit('close'): 关闭弹窗的回调
   */
  Vue.component('product-registration-dialog', {
    data: function () {
      return {};
    },
    template: `
      <div class="product-registration__dialog">
        <div class="product-registration__dialog__overlay"></div>
        <div class="product-registration__dialog__frame">
          <button
            type="button"
            v-on:click="$emit('close')"
            class="product-registration__dialog__close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M11.9999 2.3999C10.1012 2.3999 8.24515 2.96293 6.66643 4.01779C5.08772 5.07266 3.85726 6.57197 3.13066 8.32614C2.40406 10.0803 2.21395 12.0106 2.58437 13.8728C2.95479 15.735 3.8691 17.4455 5.21168 18.7881C6.55427 20.1307 8.26482 21.045 10.127 21.4154C11.9893 21.7859 13.9195 21.5957 15.6737 20.8691C17.4278 20.1425 18.9272 18.9121 19.982 17.3334C21.0369 15.7547 21.5999 13.8986 21.5999 11.9999C21.5999 9.45382 20.5885 7.01203 18.7881 5.21168C16.9878 3.41133 14.546 2.3999 11.9999 2.3999ZM16.2479 14.5439C16.4739 14.7699 16.6008 15.0763 16.6008 15.3959C16.6008 15.7155 16.4739 16.0219 16.2479 16.2479C16.0219 16.4739 15.7155 16.6008 15.3959 16.6008C15.0763 16.6008 14.7699 16.4739 14.5439 16.2479L11.9999 13.6919L9.45591 16.2479C9.22994 16.4739 8.92347 16.6008 8.60391 16.6008C8.28435 16.6008 7.97787 16.4739 7.75191 16.2479C7.52594 16.0219 7.399 15.7155 7.399 15.3959C7.399 15.0763 7.52594 14.7699 7.75191 14.5439L10.3079 11.9999L7.75191 9.4559C7.52594 9.22994 7.399 8.92346 7.399 8.6039C7.399 8.28434 7.52594 7.97787 7.75191 7.7519C7.97787 7.52594 8.28435 7.39899 8.60391 7.39899C8.92347 7.39899 9.22994 7.52594 9.45591 7.7519L11.9999 10.3079L14.5439 7.7519C14.7699 7.52594 15.0763 7.39899 15.3959 7.39899C15.7155 7.39899 16.0219 7.52594 16.2479 7.7519C16.4739 7.97787 16.6008 8.28434 16.6008 8.6039C16.6008 8.92346 16.4739 9.22994 16.2479 9.4559L13.6919 11.9999L16.2479 14.5439Z" fill="#1A1A1A"/>
            </svg>
          </button>
          <div class="product-registration__dialog__frame-content">
            <slot></slot>
          </div>
        </div>
      </div>
    `
  });

  // 根实例
  window.productRegistrationVue = new Vue({
    el: '.product-registration',
    delimiters: ['${', '}'],
    data() {
      return {
        registeredProducts: [],
        registeredProductsLoading: true,
        unregisteredProducts: [],
        unregisteredProductsLoading: true,
        route: '/',
        routes: {
          default: '/',
          registerProduct: '/register-product',
          registerProductSuccess: '/register-product/success',
          registerProductFailed: '/register-product/failed',
        },
        registerForm: {
          reRegisterId: null, // 用于重新注册.
          sn: null,
          product_id: null,
          product_name: null,
          purchase_date: null,
          purchase_channel: null,
          purchase_channel_id: null,
          order_number: null,
          phone: null,
          phone_country_code: '+1',
          email: window.productRegistration.customer.email,
          shopfiy_user_id: window.productRegistration.customer.id,
          country_code: window.productRegistration.countryCode,
        },
        // 选择的手机地区码索引
        selectedPhoneCountryIndex: 0,
        // 表单注册产品的失败码
        formErrorCode: null,
        // 重新注册弹窗对应的产品，为 null 时隐藏弹窗
        reRegisterDialogProduct: null,
        // 显示 SN 选择产品浮窗
        showSnSkuSelector: false,
        // SN 选择产品的 Loading
        snSkuSelectorLoading: false,
        // Confirm 按钮的 loading 状态
        confirmLoading: false,
        // 渠道
        purchaseChannelList: null,
        // SN help 弹窗
        showSnDialog: false,
        // 展示手机号不合法的提示
        showIllegalPhoneNumber: false,
        // 是否已配网设备的表单
        isConfiguredProductForm: false,
        // SN查询的产品列表
        snProductList: [],
        // 国际区号
        dialingCodes: [],
        lostImage: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTg3IiBoZWlnaHQ9IjE4NyIgdmlld0JveD0iMCAwIDE4NyAxODciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjE4NyIgaGVpZ2h0PSIxODciIHJ4PSI4IiBmaWxsPSIjRjVGNUY1Ij48L3JlY3Q+PHBhdGggZD0iTTc3LjYxMDkgMTE2LjE5M0g2Ni42Njg2TDg2Ljg5NTMgOTUuMDMwM0w5MC4yMTEyIDk3LjU4Nkw4OC43OTAxIDc5LjcxOTdMMTA0LjQ2OSA3MC43MTVMMTA0Ljc3NyA2M0g1OFYxMjNINzYuMzMxOUw3Ny42MTA5IDExNi4xOTNaTTc2LjQ1MDQgNzMuOTYzNEM3Ny43NjMgNzMuOTU4NiA3OS4wNDc1IDc0LjM0NjkgODAuMTQxMiA3NS4wNzg5QzgxLjIzNDkgNzUuODEwOSA4Mi4wODg2IDc2Ljg1MzcgODIuNTk0MSA3OC4wNzUzQzgzLjA5OTcgNzkuMjk3IDgzLjIzNDQgODAuNjQyNCA4Mi45ODEyIDgxLjk0MTNDODIuNzI4IDgzLjI0MDIgODIuMDk4MyA4NC40MzQxIDgxLjE3MTggODUuMzcxOEM4MC4yNDUyIDg2LjMwOTUgNzkuMDYzNiA4Ni45NDg5IDc3Ljc3NjYgODcuMjA4OUM3Ni40ODk1IDg3LjQ2ODkgNzUuMTU0OSA4Ny4zMzc4IDczLjk0MTcgODYuODMyM0M3Mi43Mjg1IDg2LjMyNjkgNzEuNjkxNCA4NS40Njk3IDcwLjk2MTYgODQuMzY5M0M3MC4yMzE5IDgzLjI2OSA2OS44NDIzIDgxLjk3NSA2OS44NDIzIDgwLjY1MTNDNjkuODQyMyA3OC44ODE3IDcwLjUzNzggNzcuMTg0MiA3MS43NzYzIDc1LjkzMDZDNzMuMDE0OSA3NC42NzcxIDc0LjY5NTYgNzMuOTY5NyA3Ni40NTA0IDczLjk2MzRaTTExNS4xNTEgNjNMMTE0LjIyNyA3MC41TDk4LjMzNSA4NS44ODIyTDk3LjQ1ODcgMTAzLjE3NUw5OC42MTkyIDEwNC4wODNMMTExLjIxOSA4OS45MTg4TDEyMi4yNTcgMTAzLjA1NlYxMTYuMTkzSDgyLjY1NThMODEuNTE4OSAxMjNIMTI5LjA1NFY2M0gxMTUuMTUxWiIgZmlsbD0iI0E4QThBOCI+PC9wYXRoPjwvc3ZnPg==',
        // 返回质保卡页面
        backToWarranty: false,
        // 一键修改订单日期的 Loading
        isModifyNowLoading: false,
        // 一键修改订单日期的错误提示
        modifyNowFailedMessage: null,
        // 显示待审核时待机保修卡的提示
        isShowUnderReviewWarrantyCardAlert: false,
      }
    },
    watch: {
      route(value) {
        document.body.setAttribute('data-route', value);
        this.resizeFooter();
      },
      unregisteredProducts(value) {
        if (value.length > 0) {
          document.body.setAttribute('data-unregistered-products', '');
        } else {
          document.body.removeAttribute('data-unregistered-products');
        }
        this.resizeFooter();
      },
      selectedPhoneCountryIndex(value) {
        if (this.dialingCodes?.length > 0) {
          this.registerForm.phone_country_code = this.dialingCodes[value]?.dialing_code ?? '+1';
        }
      },
    },
    computed: {
      // SN 选择产品 SKU 名称
      selectSnProductName() {
        return this.snProductList?.find(v => v.id == this.registerForm.product_id)?.name ?? this.registerForm.product_name;
      },
      // SN 选择产品
      selectSnProduct() {
        return this.snProductList?.find(v => v.id == this.registerForm.product_id);
      },
      // 表单按钮在特定情况下开启关闭
      formConfirmButtonDisabled() {
        const invalidity = this.invalidity;
        if (this.showIllegalPhoneNumber) {
          return true;
        }
        if (this.isConfiguredProductForm) {
          return invalidity(this.registerForm.sn);
        } else {
          return invalidity(this.registerForm.sn) || invalidity(this.registerForm.product_id) || invalidity(this.registerForm.purchase_date)
            || invalidity(this.registerForm.purchase_channel_id) || invalidity(this.registerForm.order_number);
        }
      },
      // 匹配是否线下渠道
      isOfflineChannels() {
        return function (channelId) {
          const findChannel = this.purchaseChannelList.find((channel) => channel.id == channelId);
          return findChannel ? findChannel.no_check_order > 0 : false;
        }
      }
    },
    beforeMount() {
      // 滚动后收回日期选择 
      // window.addEventListener('scroll', () => {
      //   this.$refs.registerformDateInput?.blur();
      // }); 
      // 路由跳转
      const hash = window.location.hash.replace('#', '').split('?')[0];
      if (hash != null && hash != '') {
        const hashCamelCase = hash.replace(/-([a-z])/g, (match, p1) => p1.toUpperCase());;
        const route = this.routes[hashCamelCase];
        if (route) this.route = route;
      }
      if (this.getUrlQueryString(window.location.href, 'from') == 'warranty') {
        this.backToWarranty = true;
        this.route = this.routes.registerProduct;
      }
      document.body.setAttribute('data-route', this.route);
      // 初始化
      this.initData().catch((err) => {
        console.error(err);
        throw err;
      });;
    },
    created() {
      this.debouncedHandleInputSn = this.debounce(this.debouncedInputSn, 300);
      this.resizeFooter();
    },
    mounted() {
      this.$el.classList.remove('vue--loading');
    },
    methods: {
      getUrlQueryString(url, paramKey) {
        let urlObj = new URL(url);
        var reg = new RegExp("(^|&)" + paramKey + "=([^&]*)(&|$)", "i");
        var r = urlObj.search.substr(1).match(reg);
        if (r != null) {
          return (r[2]);
        }
        return null;
      },
      // 初始化数据
      async initData() {
        await this.getRegisteredproducts();
        await this.getUnregisteredproducts();
        await this.getDialingCodes();
        await this.getPurchaseChannelList();
      },
      invalidity(value) {
        return value == null || value == '';
      },
      /**
       * 初始化产品注册表单
       * @param {*} product 可选，已配网的产品
       */
      initProductRegisterForm(product) {
        if (product) {
          this.registerForm = {
            reRegisterId: null,
            sn: product.sn,
            product_id: product.product_id,
            product_name: product.name,
            purchase_date: null,
            purchase_channel: null,
            purchase_channel_id: null,
            order_number: null,
            phone: null,
            phone_country_code: '+1',
            email: window.productRegistration.customer.email,
            shopfiy_user_id: window.productRegistration.customer.id,
            country_code: window.productRegistration.countryCode,
          };
          this.isConfiguredProductForm = true;
        } else {
          this.registerForm = {
            reRegisterId: null,
            sn: null,
            product_id: null,
            product_name: null,
            purchase_date: null,
            purchase_channel: null,
            purchase_channel_id: null,
            order_number: null,
            phone: null,
            phone_country_code: '+1',
            email: window.productRegistration.customer.email,
            shopfiy_user_id: window.productRegistration.customer.id,
            country_code: window.productRegistration.countryCode,
          };
          this.isConfiguredProductForm = false;
        }
        this.selectedPhoneCountryIndex = 0;
        this.snProductList = [];
        this.formErrorCode = null;
      },
      async getRegisteredproducts() {
        this.registeredProductsLoading = true;
        return request(api.registeredproducts, {
          email: window.productRegistration.customer.email
        }).then((res) => {
          this.registeredProducts = res.data.list;
        }).finally(() => this.registeredProductsLoading = false);
      },
      async getUnregisteredproducts() {
        this.unregisteredProductsLoading = true;
        return request(api.unregisteredproducts, {
          email: window.productRegistration.customer.email,
          language: window.productRegistration.languageCode
        }).then((res) => {
          this.unregisteredProducts = res.data.list;
        }).finally(() => this.unregisteredProductsLoading = false);
      },
      async getPurchaseChannelList() {
        return request(api.purchaseChannelList, {
          country_code: window.productRegistration.countryCode
        }).then((res) => {
          this.purchaseChannelList = res.data.list;
        }).catch((err) => {
          setTimeout(() => {
            if (this.purchaseChannelList == null) {
              console.error(err);
              this.getPurchaseChannelList();
            }
          }, 500);
        });
      },
      // 各个国家或地区的区号
      async getDialingCodes() {
        const data = await fetch(window.productRegistration.dialingCodesUrl);
        const object = await data.json();
        this.dialingCodes = object;
      },
      formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      formatOrderDateTimestamp(timestamp) {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
      },
      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      },
      // 滚动到主视图
      scrollToContainer() {
        const contaner = document.querySelector('.product-registration__container');
        if (contaner && (window.scrollY + 40) > contaner.offsetTop) {
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }, 400);
        }
      },
      handleClickWarrantyCardLink(event, product) {
        if (product.audit_status == 0) {
          // Under review
          this.isShowUnderReviewWarrantyCardAlert = true;
          event.preventDefault();
        } else if (product.audit_status != 1) {
          console.warn("audit_status not is 1, action by handleClickWarrantyCardLink: ", event, product)
        }
      },
      // 审核不通过时，重新注册
      handleRegistrationFailedReRegister(product) {
        this.isConfiguredProductForm = false;
        this.route = this.routes.registerProduct;
        this.initProductRegisterForm();
        this.registerForm.reRegisterId = product.id;
        this.reRegisterDialogProduct = null;
        this.scrollToContainer();
      },
      // 审核不通过时，一键修改注册信息
      handleRegistrationFailedModify(product) {
        if (this.isModifyNowLoading) return;
        this.isModifyNowLoading = true;
        request(api.modifyPurchaseDate, {
          id: product.id,
          purchase_date: product.order_complete_date,
        }).then((res) => {
          if (!res.success) {
            // Alert error
            console.error(res)
            this.modifyNowFailedMessage = res.msg;
          } else {
            // Success
            product.audit_status = 1;
          }
        }).catch((err) => {
          console.error(err);
          this.modifyNowFailedMessage = err.toString();
        }).finally(() => {
          this.isModifyNowLoading = false;
        });
      },
      // Register Now
      handleClickRegisterNow(product) {
        this.initProductRegisterForm(product);
        this.route = this.routes.registerProduct;
        this.scrollToContainer();
      },
      // Add More Products
      handleClickAddMoreProducts() {
        this.initProductRegisterForm();
        this.route = this.routes.registerProduct;
        this.scrollToContainer();
      },
      handleClickSnQuestion() {
        this.showSnDialog = true;
      },
      handleInputSn(e) {
        const sn = e.target.value?.trim()?.toUpperCase() ?? '';
        this.registerForm.sn = sn;
        if (sn != '' && sn != null) {
          this.snProductList = [];
          this.snSkuSelectorLoading = true;
          this.registerForm.product_id = null;
          this.registerForm.product_name = null;
          this.debouncedHandleInputSn(e);
        } else {
          this.registerForm.product_id = null;
          this.registerForm.product_name = null;
          this.showSnSkuSelector = false;
          this.snSkuSelectorLoading = false;
        }
      },
      debouncedInputSn(e) {
        const sn = e.target.value.trim();
        if (sn == '' || sn == null) {
          // this.showSnSkuSelector = false;
          // this.snProductList = [];
          // this.registerForm.product_id = null;
          // this.registerForm.product_name = null;
          return;
        }
        // 根据 SN 匹配产品
        request(api.snProductList, {
          sn: sn,
        }).then((res) => {
          // 如果输入框值发生变化，忽略此次请求结果
          if (sn != e.target.value) {
            return;
          }
          if (!res.success || res.success == "false") {
            this.snProductList = [];
          } else {
            this.snProductList = res.data.List;
            // this.showSnSkuSelector = res.data.List.length > 1; 
            if (res.data.List.length > 1) {
              this.showSnSkuSelector = true;
            } else if (!this.showSnSkuSelector && res.data.List.length == 1 && res.data.List[0]?.id != null) {
              // 未显示sn产品选择弹窗，且sn产品列表只有一项时
              this.registerForm.product_id = res.data.List[0].id;
            }
          }
          this.snSkuSelectorLoading = false;
        }).catch((err) => {
          console.error(err);
          this.snSkuSelectorLoading = false;
        });
      },
      // 日期选择器的兼容
      handleClickDateInput(e) {
        const target = e.target;
        // if (target.showPicker) {
        //   target.showPicker();
        // }
        if (!target._flatpickr) {
          flatpickr(target, {
            maxDate: 'today',
            disableMobile: "true"
          }).open();
        }
      },
      // SN 选择了产品
      handleSelectSnProductSku(product) {
        this.registerForm.product_id = product.id;
        this.showSnSkuSelector = false;
      },
      // SN 点击产品名称，重新选择 SKU
      handleClickSnSkuProductName() {
        if (!this.snProductList?.length) {
          this.snSkuSelectorLoading = true;
          request(api.snProductList, {
            sn: this.registerForm.sn,
          }).then((res) => {
            if (!res.success || res.success == "false") {
              this.snProductList = [];
              return;
            }
            this.snProductList = res.data.List;
          }).catch((err) => {
            console.error(err);
          }).finally(() => this.snSkuSelectorLoading = false);
        }
        this.showSnSkuSelector = !this.showSnSkuSelector;
      },
      handleCLickChannelSelect() {
        if (this.purchaseChannelList == null || this.purchaseChannelList.length == 0) this.getPurchaseChannelList();
      },
      handleInputPhoneNumber(e) {
        const value = e.target.value?.replace(/\D/g, '');
        this.registerForm.phone = value;
        this.showIllegalPhoneNumber = false;
      },
      checkPhoneNumber(value) {
        return /^\d{7,11}$/.test(value);
      },
      handleChangePhoneNumber(e) {
        const value = e.target.value;
        if (value == '') {
          this.showIllegalPhoneNumber = false;
        } else {
          const isValid = this.checkPhoneNumber(value);
          this.showIllegalPhoneNumber = !isValid;
        }
      },
      // 聚焦日期选择
      focusPurchaseDate(e) {
        const target = e.target;
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedDate = `${yyyy}-${mm}-${dd}`;
        target.setAttribute('max', formattedDate);
      },
      handleCancelAddProduct() {
        if (this.backToWarranty) {
          // 返回质保卡页
          window.location.href = `${window.theme.routes.root_url}pages/account-warranty`;
          // window.history.length > 1
          //   ? window.history.back() :
          //   window.location.href = `${window.theme.routes.root_url}pages/account-warranty`;
        } else {
          this.route = this.routes.default;
          this.scrollToContainer();
        }
      },
      handleConfirmAddProduct() {
        const validity = this.$refs.registerformElement.reportValidity();
        if (!validity || this.confirmLoading) return;
        // 检查手机号格式
        if (this.registerForm.phone != null && this.registerForm.phone != '' && !this.checkPhoneNumber(this.registerForm.phone)) {
          this.showIllegalPhoneNumber = true;
          return;
        }
        // 未配网的设备，必须有Product id
        if (!this.isConfiguredProductForm && (this.selectSnProduct == null || this.selectSnProduct == '')) return;
        this.confirmLoading = true;
        const registerForm = this.registerForm;
        // 传数据
        let data = {
          id: registerForm.reRegisterId,
          email: registerForm.email,
          order_number: registerForm.order_number,
          purchase_channel_id: registerForm.purchase_channel_id != null ? Number(registerForm.purchase_channel_id) : null,
          purchase_channel: this.purchaseChannelList.find(v => v.id == registerForm.purchase_channel_id)?.name,
          purchase_date: registerForm.purchase_date ? Math.floor(new Date(registerForm.purchase_date).getTime() / 1000) : null,
          shopfiy_user_id: registerForm.shopfiy_user_id?.toString(),
          sn: registerForm.sn?.toUpperCase(),
          country_code: registerForm.country_code,
          product_id: registerForm.product_id,
          timezone: window.productRegistration.timezone,
        };
        // 手机号码
        if (!!registerForm.phone && !!registerForm.phone_country_code) {
          data = { ...data, ...{ phone: registerForm.phone, phone_country_code: registerForm.phone_country_code, } };
        }
        // 去除空值
        const cleanedData = Object.entries(data).reduce((acc, [key, value]) => {
          if (value != null) {
            acc[key] = value;
          }
          return acc;
        }, {});
        request(cleanedData.id != null ? api.productReRegister : api.productRegister, cleanedData).then((res) => {
          if (res.success || res.success == "true") {
            this.route = this.routes.registerProductSuccess;
            this.formErrorCode = null;
          } else {
            this.formErrorCode = res.code;
            this.route = this.routes.registerProductFailed;
          }
          // 注册成功后刷新列表
          this.getRegisteredproducts();
          this.getUnregisteredproducts();
        }).catch((err) => {
          this.route = this.routes.registerProductFailed;
          console.error(err);
        }).finally(() => {
          this.confirmLoading = false;
          if (window.innerWidth < 589) {
            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 200);
          }
        });
      },
      // 注册成功，返回
      handleSuccessReturn() {
        // 特殊情况下返回质保卡页
        if (this.backToWarranty) {
          window.location.href = `${window.theme.routes.root_url}pages/account-warranty`;
          // window.history.length > 1
          //   ? window.history.back() :
          //   window.location.href = `${window.theme.routes.root_url}pages/account-warranty`;
        } else {
          this.route = this.routes.default;
        }
      },
      // 移动端未注册产品遮挡页脚
      resizeFooter() {
        const footerContent = document.querySelector('.site-footer>*:last-child');
        const aside = document.querySelector('.product-registration__aside');
        if (footerContent && aside) {
          footerContent.style.setProperty('--margin-bottom', aside.clientHeight + 'px');
        } else {
          footerContent.style.setProperty('--margin-bottom', 0 + 'px');
        }
      }
    }
  });
})();
